export class SaveAccountRequest {
  FirstName: string = '';
  LastName: string = '';
  PhoneNumber: string = '';
  CompanyId: number;  
}
